<template>
  <div>
    <b-row>
        <b-col>
          <b-form-group
            label="Year"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.year"
              placeholder="Enter year"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Cost Center"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.cost_center"
              placeholder="Enter cost center"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Plan Code"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.plan_code"
              placeholder="Enter plan code"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Main Account"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.main_account"
              placeholder="Enter main account"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Sub Account"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.sub_account"
              placeholder="Enter sub account"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="Line"
            label-size="sm"
            label-class="font-weight-bold"
          >
            <b-form-input
              autocapitalize="off"
              v-model="detail.line"
              placeholder="Enter line"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      types: Object,
      default: () => (
        {
          year: '',
          costCenter: '',
          planCode: '',
          mainAccount: '',
          subAccount: '',
          line: ''
        }
      )
    }
  }
}
</script>
